export default __webpack_public_path__ + "static/media/signal-low.fd2639e5.svg";